export default "__VITE_ASSET__kRWHrWMw__"